import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Button,
  Autocomplete,
} from "@mui/material";
import { Box, TextField } from "@mui/material";
import ProgressCom from "../../../components/ProgressCom";
import CustomPagination from "../../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import ClearIcon from "@mui/icons-material/Clear";
import { UseDiscountCode } from "./UseDiscountCode";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteRow from "../../../components/DeleteRow";
import DeleteIcon from "@mui/icons-material/Delete";
import { rsProgress } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import YesOrNoDialoge from "../../../components/YesOrNoDialoge";

export default function CodeSMS(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getDiscountCodeUser, getDiscountCodesms, addDiscountCodesms } =
    UseDiscountCode();
  const [usersLength, setUsersLength] = useState();
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [smsLists, setSmsLists] = useState([]);
  const [addUsersList, setAddUsersList] = useState(false);
  const [addUser, setAddUser] = useState(false);
  const [state, setState] = useState({
    discountID: props.DiscountID,
    SMSID: "",
  });
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
  });
  useEffect(() => {
    getDiscountCodesms((callback) => {
      setSmsLists(callback);
    });
  }, [props.DiscountID]);

  useEffect(() => {
    if (props.length == 0) {
      setState({
        ...state,
        SMSID: undefined,
      });
    }
  }, [props.length]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mt: 3 }}>
      <Autocomplete
        size="small"
        value={state.SMSID ? state.SMSID : ""}
        onChange={(evt, newValue) => {
          if (newValue) {
            setState({ ...state, SMSID: newValue });
          } else {
            setState({
              ...state,
              SMSID: undefined,
            });
          }
        }}
        isOptionEqualToValue={(option, value) => {
          return value == "" || option === value;
        }}
        getOptionLabel={(option) => {
          if (option) {
            return smsLists.find((m) => m.id == option).title;
          }
          return "";
        }}
        fullWidth
        options={smsLists.map((m) => m.id)}
        renderInput={(params) => (
          <TextField variant="outlined" {...params} label="پیغام SMS" />
        )}
      />
      <Button
        disabled={props.length > 0 ? false : true}
        variant="contained"
        onClick={() => {
          if (!state.SMSID) {
            enqueueSnackbar("لطفا پیغام SMS را انتخاب کنید", {
              variant: "error",
              autoHideDuration: 2000,
              preventDuplicate: true,
            });
            return;
          }
          setCheckState({ name: "تولید SMS", show: true });
        }}
      >
        ایجاد
      </Button>
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          setProgress(true);
          addDiscountCodesms(state, () => {
            props.setShowSMS(false);
          });
        }}
      />
    </Box>
  );
}
